"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

const IconRadiatorSupport = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/_react.default.createElement("title", null, title) : null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M18 22.865c0 .627-.508 1.135-1.135 1.135H7.099a1.135 1.135 0 01-1.135-1.135V1.135C5.964.508 6.472 0 7.099 0h9.766C17.492 0 18 .508 18 1.135v21.73zm-1.702-.568V1.703H7.666v20.594h8.632z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.322 16.87a4.392 4.392 0 11-8.784 0 4.392 4.392 0 018.784 0zm-1.703 0a2.69 2.69 0 10-5.378 0 2.69 2.69 0 005.378 0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.316 16.87a1.386 1.386 0 11-2.772 0 1.386 1.386 0 012.772 0zm-1.07 0a.316.316 0 10-.632 0 .316.316 0 00.632 0zm4.076-9.775a4.392 4.392 0 11-8.784 0 4.392 4.392 0 018.784 0zm-1.703 0a2.69 2.69 0 10-5.378 0 2.69 2.69 0 005.378 0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.316 7.095a1.386 1.386 0 11-2.772 0 1.386 1.386 0 012.772 0zm-1.07 0a.316.316 0 10-.632 0 .316.316 0 00.632 0z"
  }));
};

const ForwardRef = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(IconRadiatorSupport, (0, _extends2.default)({
  svgRef: ref
}, props)));

var _default = ForwardRef;
exports.default = _default;